import React from "react";
import PropTypes from "prop-types";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const ProcessingFeeModal = ({ isOpen, onClose, deductibles }) => {
  const freightFee = 200;
  const processingFee = 1000;
  const minProcessingFee = deductibles - freightFee;
  const subTotal = processingFee - deductibles;
  const gst = subTotal * 0.1;
  const totalPrice = subTotal + gst;
  const handleOnClose = () => {
    onClose();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="large"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
      blurred
    >
      <div
        className="processing-fee"
        data-testid="processing-fee-modal-content"
      >
        <h3 className="title">Sample Processing Fee</h3>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="header-title">Item</div>
            <div className="header-title">Price</div>
          </div>
          <div className="content-list">
            <div className="content-title">Processing Fee</div>
            <div className="content-price">$1000.00</div>
          </div>
          <div className="content-group">
            <div className="content-items">
              <div className="item">200 hectares @ $4/ha processed</div>
              <div className="price">$800.00</div>
            </div>
            <div className="content-items">
              <div className="item">Freight Fee</div>
              <div className="price">${freightFee.toFixed(2)}</div>
            </div>
          </div>
          <div className="content-list">
            <div className="content-title">
              Minimum Upfront Hire Fee (Deductible)
            </div>
            <div className="content-price">-${deductibles.toFixed(2)}</div>
          </div>
          <div className="content-group">
            <div className="content-items">
              <div className="item">Minimum Processing Fee</div>
              <div className="price">-${minProcessingFee.toFixed(2)}</div>
            </div>
            <div className="content-items">
              <div className="item">Freight Fee</div>
              <div className="price">-${freightFee.toFixed(2)}</div>
            </div>
          </div>
          <div className="content-list">
            <div className="content-title">Subtotal Price</div>
            <div className="content-price">${subTotal.toFixed(2)}</div>
          </div>

          <div className="box">
            <div className="box-list">
              <div className="box-title">Amount Due</div>
              <div className="box-price">
                ${subTotal > 0 ? subTotal.toFixed(2) : 0.0}
              </div>
            </div>
            <div className="box-list">
              <div className="box-title">GST</div>
              <div className="box-price">${gst > 0 ? gst.toFixed(2) : 0.0}</div>
            </div>
            <div className="box-list">
              <div className="box-title">Total Price</div>
              <div className="box-price">
                ${totalPrice > 0 ? totalPrice.toFixed(2) : 0.0}
              </div>
            </div>
          </div>
        </div>
        <Button
          type="outlined"
          color="white"
          id="ok-button"
          label="Close"
          block
          onClick={handleOnClose}
        />
      </div>
    </CustomModal>
  );
};

ProcessingFeeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  deductibles: PropTypes.string.isRequired,
};

export default ProcessingFeeModal;
